<template>
  <div id="lp-invoices">
    <div class="ui large header">{{ $t('Invoices') }}</div>
    <div class="row">
      <div class="column">
        <div class="ui">
          <Pagination ref="PaginationTop" v-on:paginationUpdated="fetchInvoices" paginationSettingsKey="invoices"></Pagination>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="column">
        <div class="ui grid">
          <div class="row">
            <div class="four wide column">
              <button class="ui right labeled icon button" v-on:click="createInvoice()">
                <i class="right plus icon"></i> {{ $t('Create Invoice') }}
              </button>
            </div>
            <div class="four wide column">
              <div class="ui input action search">
                <input type="text" :placeholder="$t('Search')" v-model="search" v-on:change="fetchInvoices"/>
                <button class="ui icon button" v-on:click="fetchInvoices">
                  <i class="search icon"></i>
                </button>
              </div>
            </div>
          </div>
          <sui-grid-row class="">
            <div class="column sixteen wide">
              <div class="row">
                <div class="column wide sixteen">
                  <div class="ui grid padded">
                    <sui-grid-row class="invoice-header">
                      <sui-grid-column :width="2">{{ $t('Invoice Number') }}</sui-grid-column>
                      <sui-grid-column :width="3">{{ $t('Publisher') }}</sui-grid-column>
                      <sui-grid-column :width="3">{{ $t('Publication') }}</sui-grid-column>
                      <sui-grid-column :width="2">{{ $t('Product') }}</sui-grid-column>
                      <sui-grid-column :width="3">{{ $t('Invoice Date') }}</sui-grid-column>
                      <sui-grid-column :width="3">{{ $t('Status') }}</sui-grid-column>
                    </sui-grid-row>
                    <div class="row invoice-row" v-for="(item, index) in invoices" :key="index" v-bind:class="[{ expanded: expandInvoice(index) }]" v-bind:id="'invoice-row-'+item.invoice.id">
                      <div class="grid ui padded">
                        <div class="row invoice-row-main valign-child-center" v-bind:class="[getUpdatedState(index) ? 'saved' : '']">
                          <sui-grid-column :width="2">{{ item.invoice.invoice_number }}</sui-grid-column>
                          <sui-grid-column :width="3">{{ item.invoice.publisher.name }}</sui-grid-column>
                          <sui-grid-column :width="3">{{ item.invoice.publications.map(p => p.code.toUpperCase()).join(', ') }}</sui-grid-column>
                          <sui-grid-column :width="2">{{ item.invoice.product }}</sui-grid-column>
                          <sui-grid-column :width="3">{{ item.invoice.invoice_date }}</sui-grid-column>
                          <sui-grid-column :width="2">
                            <i class="large clock icon" v-if="getStatus(index) === 'pending'"></i>
                            <i class="large check icon" v-else-if="getStatus(index) === 'paid'"></i>
                            <i class="large minus circle icon" v-else-if="getStatus(index) === 'cancelled'"></i>
                          </sui-grid-column>
                          <sui-grid-column :width="1">
                            <span class="expand-invoice-row" v-on:click="expand(index, $event)">
                              <i class="caret down icon"></i>
                            </span>
                          </sui-grid-column>
                        </div>
                        <div class="grid ui row padded stackable invoice-extra" v-bind:id="'invoice-extra-'+item.invoice.id">
                          <div class="row equal width invoice-row-extra">
                            <div class="column valign-child-center">
                              <table class="ui celled striped table">
                                <tbody>
                                  <tr>
                                    <td class="collapsing">
                                      <i class="calendar icon"></i> {{ $t('From') }}
                                    </td>
                                    <td>{{ item.invoice.invoice_start_date }}</td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <i class="calendar icon"></i> {{ $t('To') }}
                                    </td>
                                    <td>{{ item.invoice.invoice_end_date }}</td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <i class="calendar icon"></i> {{ $t('Due') }}
                                    </td>
                                    <td>{{ item.invoice.invoice_due_date }}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <div class="column">
                              <table class="ui celled striped table">
                                <tbody>
                                  <tr>
                                    <td class="collapsing">
                                      <div class="ui labeled button" tabindex="0">
                                        <button class="ui right icon button" v-on:click="updateInvoiceStatus(index, item.invoice.id, statusChanged(index), $event)" v-bind:class="[statusChanged(index) ? 'red' : 'disabled']">
                                          {{ $t('Save') }}
                                        </button>
                                        <sui-dropdown
                                          placeholder="Status"
                                          selection
                                          fluid
                                          :options="item.options"
                                          v-model="item.statusValue"
                                          v-bind:id="'invoice-update-status-' + item.invoice.id"
                                        />
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <div class="column">
                              <table class="ui celled striped table">
                                <tbody>
                                  <tr>
                                    <td class="collapsing">
                                      <button class="ui right labeled icon button teal invoice" v-on:click.prevent="open(index, item.invoice.id)" v-bind:class="[invoiceLoading(index) ? 'loading' : '']">
                                        <i class="right eye icon"></i> {{ $t('View') }}
                                      </button>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="collapsing">
                                      <a class="ui right labeled icon button teal invoice" v-bind:href="item.invoice.document" target="_blank">
                                        <i class="right download icon"></i> {{ $t('Download') }}
                                      </a>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="collapsing">
                                      <button class="ui right labeled icon button teal invoice" v-on:click="send_mail(item.invoice.id)" >
                                        <i class="right envelope icon"></i> {{ $t('Send Invoice') }}
                                      </button>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <sui-dimmer :active="loading" inverted>
              <sui-loader />
            </sui-dimmer>
          </sui-grid-row>
        </div>
      </div>
    </div>
    <sui-modal v-model="openInvoice" size="fullscreen">
      <i class="close icon" v-on:click="closeModal()"></i>
      <sui-modal-header>{{ currentInvoice }}</sui-modal-header>
      <sui-modal-content scrolling>
        <iframe frameborder="0" width="100" height="100" id="invoice-view"></iframe>
      </sui-modal-content>
    </sui-modal>
  </div>
</template>

<script>

import Pagination from './Pagination';

export default {
  components: {
    Pagination
  },
  mounted() {
    this.fetchInvoices();
  },
  data() {
    return {
      invoices: [],
      openInvoice: false,
      currentInvoice: '',
      loading: false,
      search: '',
      messages: [],
    };
  },
  watch: {
    openInvoice: function (value) {
      this.modalFix(value);
    }
  },
  methods: {
    closeModal() {
      this.openInvoice = false;
    },
    notifySaved(index) {
      let self = this;
      this.invoices[index].statusChanged = true;
      setTimeout(function () {
        self.invoices[index].statusChanged = false;
      }, 2000);
    },
    getUpdatedState(index) {
      return this.invoices[index].statusChanged;
    },
    getStatus(index) {
      return this.invoices[index].statusValue;
    },
    statusChanged(index) {
      let currentStatus = this.invoices[index].invoice.status;
      let newStatus = this.invoices[index].statusValue;
      return newStatus !== currentStatus;
    },
    updateInvoiceStatus(index, id, changed, e) {
      if (!changed) {
        e.preventDefault();
        return false;
      }
      let el = document.getElementById('invoice-update-status-' + id);
      let value = el.childNodes[0].innerText.toLowerCase();
      let client = this.$store.getters.coreapiClient;
      let action = ['crm', 'invoice', 'update'];
      let schema = this.$store.getters.coreapiSchema;
      let params = {
        id: id,
        status: value
      };
      client.action(schema, action, params).then((result) => {
        this.invoices[index].invoice = result;
        this.invoices[index].statusValue = result.status;
        this.statusChanged(index);
        this.notifySaved(index);
      });
    },
    invoiceLoading(index) {
      return this.invoices[index].loading;
    },
    open(index, id) {
      let el = document.getElementById('invoice-view');
      let client = this.$store.getters.coreapiClient;
      let action = ['crm', 'invoice', 'html'];
      let schema = this.$store.getters.coreapiSchema;
      let params = {
        id: id
      };
      this.invoices[index].loading = true;
      client.action(schema, action, params).then((result) => {
        el.src = 'about:blank';
        setTimeout(function () {
          el.contentWindow.document.write(result);
        }, 0);
        this.openInvoice = true;
        this.currentInvoice = this.invoices[index].invoice.invoice_number;
        this.invoices[index].loading = false;
      });
    },
    modalFix(open) {
      let content = document.getElementById('content');
      let openClass = 'modal-open';
      if (open) {
        content.classList.add(openClass);
      } else {
        content.classList.remove(openClass);
      }
    },
    expand(index, e) {
      // TODO: Make this height dynamic by detecting child
      // element heights
      this.$nextTick(function () {
        // let el = document.getElementById('invoice-extra-' + id);
        this.invoices[index].show = !this.invoices[index].show;
      });
    },
    createInvoice() {
      this.$router.push({name: 'Create Invoice'});
    },
    expandInvoice(index) {
      return this.invoices[index].show;
    },
    fetchInvoices() {
      let client = this.$store.getters.coreapiClient;
      let action = ['crm', 'invoice', 'list'];
      let schema = this.$store.getters.coreapiSchema;
      let params = {};
      let currentPage = this.$refs.PaginationTop.pagination.currentPage;
      let limit = this.$refs.PaginationTop.limit;
      let offset = this.$refs.PaginationTop.offset;

      if (currentPage !== 0) {
        params['limit'] = limit;
        params['offset'] = offset;
      }

      if (this.search) {
        params['search'] = this.search;
      }

      this.loading = true;
      client.action(schema, action, params).then((response) => {
        let results = response.results;
        let invoices = [];
        this.$refs.PaginationTop.totalItems = response.count;
        for (var i = 0; i < results.length; i++) {
          let data = {
            show: false,
            invoice: results[i],
            statusValue: results[i].status,
            statusChanged: false,
            loading: false,
            options: [{
              text: 'Pending',
              value: 'pending',
            }, {
              text: 'Paid',
              value: 'paid',
            }, {
              text: 'Cancelled',
              value: 'cancelled',
            }]
          };
          invoices[i] = data;
        }
        this.invoices = invoices;
        this.loading = false;
      });
    },

    send_mail(invoiceId) {
      let axiosClient = this.$store.getters.axiosClient;
      let data = new FormData();
      data.set('invoice_id', invoiceId);
      axiosClient.post(`crm/send_invoice/`, data).then((response) => {
        this.$router.push({name: 'Send Invoice'});
        if (response.data === 'email sent.' && response.status === 200) {
          alert('Email sent successfully.');
        }
      })
        .catch((error) => {
          this.success = false;
          if (error.response || error.request) {
            this.messages.push(error.message);
            alert('Unable to send email.');
          } else {
            console.log('Error', error.message);
          }
        });
    },
  }
};
</script>

<style scoped>
.ui.labeled.button {
  width: 100%;
}
.ui.input.search {
  font-size: 13px;
}
.ui.button.disabled {
  cursor: not-allowed;
}
.ui.grid > .row.invoice-header {
  color: #242e59;
  font-weight: bold;
}
.ui.grid > .row.invoice-row {
  padding: 0;
  font-size: 13px;
}
.ui.grid > .row.invoice-row.expanded {
  margin-bottom: 15px;
  border: 1px solid #aaa;
}
.ui.grid > .row.invoice-row .invoice-row-main {
  padding-top: 7px;
  padding-bottom: 7px;
}
.ui.grid > .row.invoice-row:nth-child(even) .invoice-row-main {
  background-color: #eaeaea;
}
.ui.grid > .row.invoice-row:nth-child(odd) .invoice-row-main {
  background-color: #f9f9f9;
}
.ui.grid > .row.invoice-row.expanded .invoice-row-main {
  border-bottom: 1px solid #aaa;
  background-color: #40a3d6;
  color: #fff;
}

.ui.grid > .row.invoice-row .invoice-row-main.saved {
  -webkit-animation-name: flashBg;
  -webkit-animation-duration: 1500ms;
  -webkit-animation-iteration-count: 1;
  -webkit-animation-timing-function: linear;
  -moz-animation-name: flashBg;
  -moz-animation-duration: 1500ms;
  -moz-animation-iteration-count: 1;
  -moz-animation-timing-function: linear;
}

@-webkit-keyframes flashBg {
  0% {
    background-color: #40a3d6;
  }
  15% {
    background-color: #242e59;
  }
  100% {
    background-color: #40a3d6;
  }
}

.ui.grid.invoice-extra {
  opacity: 0;
  padding: 0;
  height: 0;
  visibility: hidden;
  overflow: hidden;
  transition: height 300ms, visibility 300ms, padding 300ms, opacity 300ms;
}
.ui.grid.invoice-extra.stackable {
  margin: 0 !important;
}
.ui.grid > .row.invoice-row.expanded .ui.grid.invoice-extra {
  height: 200px;
  opacity: 1;
  visibility: visible;
}
.valign-child-center > * {
  align-self: center;
}
.expand-invoice-row {
  cursor: pointer;
}
.invoice-row-extra .selection {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.invoice-date-field {
  margin-bottom: 15px;
}
.invoice-date-field span {
  align-self: center;
  display: inline-block;
}
.invoice-date-field span.invoice-date-field--date {
  border-radius: 0 4px 4px 0;
  padding: 4px 10px;
  position: relative;
  margin-left: 10px;
  border-left: 1px solid #aaa;
}
.invoice-date-field span.ui {
  min-width: 100px;
  border-radius: 4px 0 0 4px;
  padding-top: 8px;
}
@media only screen and (min-width: 1368px) {
  .invoice-row > .ui.grid {
    width: 100%;
  }
}
@media only screen and (max-width: 767px) {
  .ui.grid > .row.invoice-row.expanded .ui.grid.invoice-extra {
    height: auto;
  }
}
</style>
